
import OpenDataView from '../components/OpenData/index.vue';
import SkeletonSection from '../components/skeleton/Section.vue';
import SliderCategories from '../components/Slider.vue';
import CategorySearchComponent from "../components/Search/CategorySearch.vue";
import FrameService from "../src/FrameService";
import { mapState } from 'vuex'
import {State} from 'modules/spravochnik/dt-front-page-generator/store';

export default {
    components: {
        SkeletonSection,
        SliderCategories,
        CategorySearchComponent,
        OpenDataView
    },
    computed: mapState({
        categories: (state: State) => state.category.categories
    }),
    methods: {
        toggleBlock(block: any): void {
            if (this.showBlock.includes(block.id)) {
                const index = this.showBlock.indexOf(block.id);
                if (index > -1) {
                    this.showBlock.splice(index, 1);
                }
            } else {
                this.showBlock.push(block.id);
            }
        },
        checkBlock(blockPassed: string): any {
            return !!this.showBlock.includes(blockPassed);
        },

        async onLoading(func: () => Promise<void>) {
            document.querySelector('body').style.overflow = 'auto';
            (new FrameService()).on();
            await func();
            document.querySelector<HTMLElement>('#main-page').style.display = 'block';
        }
    },
    async mounted() {
        await this.onLoading(async () => {
            this.loading = true;
            await this.$store.dispatch('category/loadCategories');
            this.loading = false;
        })
    },
    data() {
        return {
            loading: false,
            showBlock: [],
        };
    }
};
